import type React from 'react'

interface CloseIconProps {
  size?: number | string
  color?: string
  className?: string
}

const CloseIcon: React.FC<CloseIconProps> = ({ size = 20, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Close Icon'}
      role="img"
    >
      <path
        d="M14.6697 14.0137L14.7014 14.0488C14.8506 14.2316 14.8401 14.5013 14.6697 14.6717C14.4993 14.8421 14.2296 14.8525 14.0469 14.7034L14.0118 14.6717L5.3283 5.98758C5.14662 5.80589 5.14662 5.51132 5.3283 5.32963C5.50997 5.14794 5.80453 5.14794 5.98621 5.32963L14.6697 14.0137Z"
        fill={color}
      />
      <path
        d="M5.32762 14.0137L14.0111 5.32963C14.1928 5.14794 14.4874 5.14794 14.669 5.32963C14.8507 5.51132 14.8507 5.80589 14.669 5.98758L5.98553 14.6717C5.80385 14.8533 5.50927 14.8533 5.32762 14.6717C5.14597 14.49 5.14603 14.1954 5.32762 14.0137Z"
        fill={color}
      />
    </svg>
  )
}

export default CloseIcon
